<template>
    <div class="data_back">
        <el-breadcrumb separator=">">
            <transition-group name="breadcrumb">
                <el-breadcrumb-item v-for="item in levelList" :key="item.path">
                    <router-link :to="item.path">{{item.meta.title}}</router-link>
                </el-breadcrumb-item>
            </transition-group>
        </el-breadcrumb>
<!--        <el-button type="primary" plain @click="back()">返回</el-button>-->
    </div>
</template>

<script>
export default {
    created () {
        this.getBreadcrumb()
    },
    data () {
        return {
            levelList: null
        }
    },
    watch: {
        $route () {
            this.getBreadcrumb()
        }
    },
    methods: {
        back () {
            window.history.back(-1);
        },
        getBreadcrumb () {
            let matched = this.$route.matched.filter(item => item.name);
            const first = matched[0];
            if (first && first.name !== 'Education') {
                matched = [ { path: '/education', meta: { title: '首页' }} ].concat(matched)
            }
            this.levelList = matched;
        }
    }
}
</script>

<style>
    .data_back {
        margin: 0.2rem 0;
        font-size: 0.18rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .el-breadcrumb__inner a:hover, .el-breadcrumb__inner.is-link:hover {
        color: #0e5278;
    }
</style>



// WEBPACK FOOTER //
// src/components/ivew/breadCrumb.vue